"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarRoutes = void 0;
const avatarActions_openapi_1 = require("./avatarActions.openapi");
exports.avatarRoutes = [
    {
        name: 'avatar.instruction.versions',
        path: '/instruction/:instructionId/versions',
        method: 'GET',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.instruction.versions']
        }
    },
    {
        name: 'avatar.instruction.revert',
        path: '/instruction/:instructionId/revert/:versionId',
        method: 'GET',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.instruction.revert']
        }
    },
    {
        name: 'avatar.knowledge',
        path: '/knowledge/:id',
        method: 'GET',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.knowledge']
        }
    },
    {
        name: 'avatar.processing',
        path: '/processing/:id',
        method: 'GET',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.processing']
        }
    },
    {
        name: 'avatar.fake-webhook-schema',
        path: '/webhook/fake-schema/:webhookEventName',
        method: 'GET'
    },
    {
        name: 'avatar.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.list']
        }
    },
    {
        name: 'avatar.create',
        path: ['/'],
        method: 'POST',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.create']
        }
    },
    {
        name: 'avatar.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.get']
        }
    },
    {
        name: 'avatar.update',
        path: '/:id',
        method: 'PUT',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.update']
        }
    },
    {
        name: 'avatar.patch',
        path: '/:id',
        method: 'PATCH',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.patch']
        }
    },
    {
        name: 'avatar.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: avatarActions_openapi_1.avatarOpenApiDocs['avatar.delete']
        }
    }
];
